import { AutoMap } from '@automapper/classes';
import { IsBoolean, IsDefined, IsString } from 'class-validator';

export class UsernameDto {
  @AutoMap()
  @IsString()
  @IsDefined()
  firstName: string;

  @AutoMap()
  @IsString()
  @IsDefined()
  fullName: string;

  @AutoMap()
  @IsString()
  @IsDefined()
  lastSystemName: string;

  @AutoMap()
  @IsBoolean ()
  @IsDefined()
  active: boolean;
}